import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';

import { AuthService } from './auth.service';
import { FunctionalityKey } from './models';

const PROCUREMENT_STAGES = new Set([
  'procurement-cases',
  'gem-cases',
  'e-tender-cases',
  'global-tender-cases',
  'lpc-cases',
  'open-market-cases'
]);

function routeFunctionality(route: ActivatedRouteSnapshot): FunctionalityKey | null {
  const configured = route.data['functionality'] as FunctionalityKey | undefined;
  if (configured) return configured;
  const stage = route.paramMap.get('stage');
  if (!stage) return null;
  if (stage === 'requisitions') return 'requisitions';
  return PROCUREMENT_STAGES.has(stage) ? 'procurement' : 'tendering';
}

export const accessGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const functionality = routeFunctionality(route);
  return !functionality || auth.hasAccess(functionality) ? true : router.createUrlTree(['/profile']);
};

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.currentUser?.role === 'admin' ? true : router.createUrlTree(['/profile']);
};
